 <template>
    <vx-card class="routine text-dark shadow-md hover:shadow-lg border-solid border-2 border-transparent hover:border-black cursor-pointer select-none" :cardBackground="backgroundColor" :class="{'text-white': paintItWhite}" @click.stop="$emit('openSidebar', routine)" @contextmenu.prevent="openContextMenu">
      <template v-slot:title>
        <div class="flex w-full pl-2" :class="{'opacity-50': doneToday}">
          <div class="cursor-pointer w-full">
            <div class="flex items-center w-full">

              <div class="w-3/4">
                <div class="flex items-center">
                  <DoneToday class="mr-2" :done="doneToday" @toggleDone="toggleDone" v-if="!showStreak"/>
                  <AnchoredTitle class="font-semibold" :title="routine.title" :titleClasses="doneToday ? 'line-through' : ''" :relatedAreas="routine.relatedAreas"/>
                  <!-- <p class="ml-2 font-semibold">{{routine.title}}</p> -->
                </div>


                <div v-if="showStreak" class="my-1">
                  <Streak :formatedDatesDone="formatedDatesDone" @addDay="addDay" @removeDay="removeDay" :startedOn="startedOnDate" />
                </div>

                <div class="text-sm flex items-center">

                  <p v-if="lastDayDone"> <span>
                  <feather-icon icon="RepeatIcon" class="mr-1" svgClasses="h-3 w-3" />
                  <FrequencyInWords :routine="routine"/>
                </span> |

                  <span>
                     <!-- <vx-tooltip text="last date done" delay="0.5s"> -->
                        <feather-icon icon="CheckCircleIcon" svgClasses="h-3 w-3" />
                       last {{lastDayDone | dateWord}}
                      <!-- </vx-tooltip> -->
                  </span>
                </p>
                  <p v-else> <span>
                    <feather-icon icon="RepeatIcon" class="mr-1" svgClasses="h-3 w-3" />
                    <FrequencyInWords :routine="routine"/></span></p>
                </div>

     

             <div class="flex" v-if="routine.relatedAreas">
                <LifeArea v-for="lifeArea in routine.relatedAreas" :lifeArea="lifeArea" class="mr-1" :showIcon="true" :hideText="true" size="small"/>
                    </div>
              </div>

              <div class="flex w-1/4 justify-end">
                <vx-tooltip v-if="!isFinished && active" :text="routineBatteryText" delay="2s" >
                  <vue-apex-charts class="routine-battery" type="radialBar" height="50" width="50" :options="chartOptions" :series="[successLevel]" />
                </vx-tooltip>

                <vx-tooltip v-if="isFinished" text="This routine is marked as finished. You can find it in My Journey since tomorrow" delay="2s" >
                  <feather-icon icon="AwardIcon" class="w-8 pt-1" />
                </vx-tooltip>
              </div>


            </div>
   
          </div>

          <!-- <feather-icon @click.stop="$emit('openSidebar', routine)" icon="PauseCircleIcon" class="flex justify-end cursor-pointer rotate90 w-5 text-dark" /> -->
        </div>
      </template>

    <template v-slot:actions>
      <div @click.stop="" class="flex items-center">

        <!-- <feather-icon v-if="!active" icon="PauseCircleIcon" svgClasses="h-8 w-8" /> -->

          <!-- <div class="py-1 cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full" > -->
          <feather-icon icon="MoreVerticalIcon" @click="openContextMenu" :class="actionElementCss" svgClasses="h-5 w-5" />
          <!-- </div> -->


          <context-menu id="routines-context-menu" ref="routineCtxMenu">

             <ContextMenuItem v-if="canSkip" title="won't do today" icon="MinusCircleIcon" @contextMenuClicked="skip"/>
             <ContextMenuItem v-if="canUnskip" icon="PlayIcon" title="maybe I'll do this today after all" @contextMenuClicked="unskip"/>


             <ContextMenuItem v-if="active" title="pause" icon="PauseCircleIcon" @contextMenuClicked="pause"/>

             <ContextMenuItem v-else title="activate" icon="PlayIcon" @contextMenuClicked="activate" />


           <ContextMenuItem v-if="!isFinished" title="mark as accomplished" icon="AwardIcon" @contextMenuClicked="setFinishedToday"/>

            <ContextMenuItem v-if="isFinished" title="revert from accomplished" icon="ActivityIcon" @contextMenuClicked="setUnfinished"/>

             <vs-divider class="my-1"/>

            <ContextMenuColor :value="routine.backgroundColor" @colorChanged="changeColor" :namespace="`${routine.id}-routine`" />

             <vs-divider class="my-1"/>

            <ContextMenuItem title="edit" icon="EditIcon" @contextMenuClicked="$emit('openSidebar', routine)"/>

            <ContextMenuItem title="delete" icon="Trash2Icon" @contextMenuClicked="handleDelete" color="text-danger"/>

          </context-menu>

        <feather-icon :class="actionElementCss" icon="ChevronRightIcon" svgClasses="h-5 w-5" @click.stop="$emit('openSidebar', routine)" />
        </div>
    </template>
    </vx-card>
</template>

<script>
import _ from 'lodash'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import VueApexCharts from 'vue-apexcharts'
import DoneToday from './DoneToday'
import Streak from './Streak'
import Routine from '@/models/Routine'
import { midnight, formatyyymmdd, datesDiff, addDays, areEqual, isToday, getDateObject } from '@/helpers/date'
import trackAnalytics from '@/helpers/trackAnalytics'
import LifeArea from './../Stories/LifeArea'

// import _ from 'lodash'
// import draggable from 'vuedraggable'
// import keepOrderBy from '@/helpers/keepOrderBy'


export default {
  components: {
    flatPickr,
    VueApexCharts,
    DoneToday,
    Streak,
    LifeArea
  },
  props: {
    routine: {
      type: Object,
      required: true,
    },
    showSkipToday: {
      type: Boolean,
      required: false
    }
  },

  // computed: {
  //   titleColor: "primary"
  // }
  data () {
    return {
      datesRaw: '',
      sidebarActive: false,
      chartOptions: {
        chart: {
          height: 350,
          type: 'radialBar',
          offsetY: -10,
          sparkline: {
            enabled: true
          }
        },
        plotOptions: {
          radialBar: {
            hollow: {
              // margin: 75,
              size: '10%'
            },
            // startAngle: -135,
            // endAngle: 135,
            dataLabels: {
              name: {
                fontSize: '12px',
                color: undefined,
                offsetY: 30
              },
              value: {
                show: false,
              }
            }
          }
        },
        fill: {
          colors: ['#1E1E1E'],
          type: 'solid',
          // gradient: {
          //     shade: 'dark',
          //     shadeIntensity: 0.15,
          //     inverseColors: false,
          //     opacityFrom: 1,
          //     opacityTo: 1,
          //     stops: [0, 50, 65, 91]
          // },
        },
        labels: [''],
      },
      // configdateTimePicker: {
      //   disableMobile: false,
      //   parseDate: (datestr) => midnight(new Date(datestr)),
      //   minDate: midnight(this.startedOnDate),
      //   maxDate: midnight(),
      //   // disable: [(date) => { return date < this.startedOnDate }],
      //   altInput: true, // optional
      //   altInputClass: 'hide-me',  // optional
      //   wrap: true,
      //   mode: 'multiple',
      //   locale: { firstDayOfWeek: 1 }
      // },
      // configInlineDateTimePicker: {
      //   disableMobile: false,
      //   parseDate: (datestr) => midnight(new Date(datestr)),
      //   minDate: midnight(this.startedOnDate),
      //   maxDate: midnight(),
      //   inline: true,
      //   altInput: true, // optional
      //   altInputClass: 'hide-me',  // optional
      //   // wrap: true,
      //   mode: 'multiple',
      //   locale: { firstDayOfWeek: 1 }
      // },
      addSubTaskSkeleton: null,
      subtasksArray: []
    }
  },
  watch: {
    'routine.datesRaw': {
      immediate: true,
      handler (value) {
        this.datesRaw = value
      }
    },
    'datesRaw': {
      immediate: false,
      handler () {
        const routine = this.routine
        const updateFields = { datesRaw: this.datesRaw }
        trackAnalytics(this, 'app_action', 'routine', 'routine_update_dates_done', this.$store.getters.daysFromRegistration)
        this.$store.dispatch('UPDATE_ROUTINE', {routine, updateFields })
      }
    },
  },
  methods: {
    setUnfinished () {
      const updateFields = { finishedOn: null }
      this.$store.dispatch('UPDATE_ROUTINE', { routine: this.routine, updateFields })
    },
    setFinishedToday () {
      const updateFields = { finishedOn: midnight() }
      this.$store.dispatch('UPDATE_ROUTINE', { routine: this.routine, updateFields })

      this.notifier.routineFinished(this.routine)
    },
    skip () {
      const updateFields = { lastSkipOn: midnight() }
      this.$store.dispatch('UPDATE_ROUTINE', { routine: this.routine, updateFields })
    },
    unskip () {
      const updateFields = { lastSkipOn: null }
      this.$store.dispatch('UPDATE_ROUTINE', { routine: this.routine, updateFields })
    },
    activate () {
      const updateFields = { paused: !this.routine.paused }
      this.$store.dispatch('UPDATE_ROUTINE', { routine: this.routine, updateFields })
    },
    pause () {
      const updateFields = { paused: !this.routine.paused }
      this.$store.dispatch('UPDATE_ROUTINE', { routine: this.routine, updateFields })
    },
    changeColor (backgroundColor) {
      const updateFields = { backgroundColor }
      this.$store.dispatch('UPDATE_ROUTINE', { routine: this.routine, updateFields })
    },
    openContextMenu () {
      this.$root.$emit('closeAllContextMenus')

      if (this.$refs.routineCtxMenu) {
        this.$refs.routineCtxMenu.open()
      }
    },
    handleDelete () {
      this.$store.dispatch('DELETE_ROUTINE', { routine: this.routine })
      this.$emit('saved')
    },
    openCalendar () {
      this.$forceNextTick(() => this.$refs['calendar'].fp.toggle())
    },
    addDay (date) {
      this.datesRaw = this.datesToRaw(_.unionBy(this.datesDone, [date], formatyyymmdd))

      if (isToday(date)) {
        this.$store.dispatch('PLAY_SOUND_EFFECT', 'tada')
      }

      this.notifier.completedRoutine(this.$store)
    },
    removeDay (date) {
      this.datesRaw = this.datesToRaw(_.differenceBy(this.datesDone, [date], formatyyymmdd))
    },
    toggleDone (done) {
      const today = midnight()

      if (done) {
        this.addDay(today)
        // this.datesRaw = this.datesToRaw(_.unionBy(this.datesDone, [today], formatyyymmdd))
        // this.$store.dispatch('PLAY_SOUND_EFFECT', 'tada2')

      } else {
        this.removeDay(today)
        this.datesRaw = this.datesToRaw(_.differenceBy(this.datesDone, [today], formatyyymmdd))
      }
    },
    datesToRaw (dates) {
      return _.join(_.map(dates, (date) => formatyyymmdd(date)), ', ')
    },
    datesDiff (a, b) {
      const mls = 1000 * 60 * 60 * 24
      return Math.round((a - b) / mls)
    },
    datesDoneCountAfter (minDate) {
      return _.size(_.filter(this.datesDone, (d) => d >= minDate))
    },
    ensurePercentageRange (value) {
      if (value > 96) {
        return 100
      } else if (value < 1) {
        return 1
      } else {
        return Math.round(value)
      }
    }
  },
  computed: {
    backgroundColor () {
      switch (this.routine.backgroundColor) {
      case '#000000': return 'linear-gradient(to bottom right, #000000, #4C4C4C)'
      case '#3D3270': return 'linear-gradient(to bottom right, #3D3270, #776F9A)'
      case '#424CE2': return 'linear-gradient(to bottom right, #424CE2, #7A81EA)'
      case '#FC9905': return 'linear-gradient(to bottom right, #FC9905, #FCB750)'
      case '#2196F3': return 'linear-gradient(to bottom right, #2196F3, #63B5F6)'
      case '#9C28B1': return 'linear-gradient(to bottom right, #9C28B1, #B968C8)'
      case '#E91D62': return 'linear-gradient(to bottom right, #E91D62, #EF6091)'
      case '#F34336': return 'linear-gradient(to bottom right, #F34336, #F67B72)'
      case '#FFB800': return 'linear-gradient(to bottom right, #FFB800, #FFCD4C)'
      case '#21C228': return 'linear-gradient(to bottom right, #21C229, #63D469)'
      default: return this.routine.backgroundColor
      }
    },
    isFinished () { return Routine(this.routine).isFinished() },
    isSkippedForToday () { return Routine(this.routine).skippedToday() },
    canSkip () { return this.showSkipToday && !this.isSkippedForToday && !this.doneToday },
    canUnskip () { return this.showSkipToday && this.isSkippedForToday },
    showStreak () {
      return (this.daily || this.weekly) && !this.startedToday
    },
    startedToday () {
      return areEqual(this.startedOnDate, midnight())
    },
    daily () {
      return this.routine.frequency_period === 'daily'
    },
    weekly () {
      return this.routine.frequency_period === 'week'
    },
    routineBatteryText () {
      if (this.successLevel <= 9) {
        if (this.startedToday) {
          return 'Stick to the routine\'s plan to keep this full'
        } else {
          return `This isn't going as planned (${this.successLevel}%)`
        }
      }

      if (this.successLevel > 95) {
        return `You are crushing this lately (${this.successLevel}%)`
      }

      return `Not great not terrible (${this.successLevel}%)`
    },

    // success level -------------------------------------------
    startedOnDate () {
      return _.min([...this.datesDone, this.routine.startedOn.toDate()])
    },
    successStartDays () {
      if (this.daily) {
        return _.max([this.startedOnDate, addDays(midnight(), -7)])
      } else if (this.weekly) {
        if (this.frequencyCount > 4) {
          return _.max([this.startedOnDate, addDays(midnight(), -14)])
        } else if (this.frequencyCount > 2) {
          return _.max([this.startedOnDate, addDays(midnight(), -21)])
        } else {
          return _.max([this.startedOnDate, addDays(midnight(), -28)])
        }
      } else {
        return _.max([this.startedOnDate, addDays(midnight(), this.frequencyCount > 1 ? -45 : -60)])
      }
    },
    successMax () {
      if (this.daily) {
        return datesDiff(midnight(), this.successStartDays) + 1
      } else if (this.weekly) {
        return (datesDiff(midnight(), this.successStartDays) + 1) * (this.frequencyCount / 7)
      } else {
        return (datesDiff(midnight(), this.successStartDays) + 1) * (this.frequencyCount / 30)
      }
    },
    successLevel () {
      try {
        const doneCount = this.datesDoneCountAfter(this.successStartDays)

        return this.ensurePercentageRange((100 * doneCount) / this.successMax)
      } catch (err) {
        return 100
      }

    },
    //-------------------------------------------
    frequencyCount () {
      return this.routine.frequency_count
    },
    battery () {
      return Math.round(100 - this.urgency)
    },
    paintItWhite () {
      return this.routine.backgroundColor
    },
    active () {
      return !this.routine.paused
    },
    doneToday () {
      return _.includes(this.formatedDatesDone, formatyyymmdd(midnight()))
    },
    formatedDatesDone () {
      return _.map(this.datesDone, formatyyymmdd)
    },

    datesDone () {
      if (this.datesRaw) {
        return _.map(this.datesRaw.split(','), (d) => getDateObject(d))
      } else {
        return []
      }
    },
    maxDistance () {
      if (this.routine.frequency_period === 'daily') return null

      const period = this.routine.frequency_period === 'month' ? 31 : 7
      return (period / this.routine.frequency_count)
    },
    lastDateDoneDistance () {
      if (this.lastDayDone) {

        return this.datesDiff(midnight(), this.lastDayDone)
      } else {
        const dayBeforeStart = midnight(this.routine.startedOn)
        dayBeforeStart.setDate(dayBeforeStart.getDate() - 1)

        return this.datesDiff(midnight(), dayBeforeStart)
      }
    },
    lastDayDone () {
      return _.max(this.datesDone)
    },
    datesDoneCount () {
      if (this.datesDone) {
        return this.datesDone.length
      } else {
        return 0
      }
    },
    breakingPoint () {
      const breakingPoint = midnight()

      if (this.routine.frequency_period === 'month') {
        breakingPoint.setMonth(breakingPoint.getMonth() - 1)
      } else if (this.routine.frequency_period === 'week') {
        breakingPoint.setDate(breakingPoint.getDate() - 7)
      }

      return breakingPoint
    },
    watchedDays () {
      return _.filter(this.datesDone, (date) => date > this.breakingPoint).sort((a, b) => a - b).reverse()
    },
    lastConsideredDateDone () {
      return _.last(_.take(this.watchedDays, this.routine.frequency_count))
    },
    urgency () {
      if (this.doneToday) return 0

      if (this.routine.frequency_period === 'daily') return 99

      return (_.min([this.lastDateDoneDistance / this.maxDistance, 0.99]) * 100)
    },
    urgencyColor () {
      if (this.urgency > 75) {
        return 'danger'
      } else if (this.urgency > 40) {
        return 'warning'
      } else {
        return 'primary'
      }
    },
  },
  created () {
    this.$root.$on('closeAllContextMenus', () => {
      if (this.$refs.routineCtxMenu) {
        this.$refs.routineCtxMenu.ctxVisible = false
      }
    })
  },
}

</script>

<style lang="scss">
.rotate90 {
  transform: rotate(90deg) !important;
}

.routine {
  .vx-card__header {
    padding: 0.6rem
  }
}

.routine-battery {
  position: relative;
  top: 10px;
}

</style>
